<template>
    <auth-layout>
        <Head>
            <title>Login</title>
        </Head>

        <AuthFormLogin :headline="this.$gettext('Wertarbeit für <br/>Geschäftskunden.')" route="login" register-route="register.email" />
    </auth-layout>
</template>

<script>
import AuthLayout from '@partfactory/Layouts/AuthLayout';
import AuthFormLogin from '@partfactory/Pages/Client/Auth/AuthFormLogin.vue';

export default {
    name: 'Login',
    components: {
        AuthFormLogin,
        AuthLayout,
    },
};
</script>
